module.exports = __webpack_public_path__ + "static/img/map.1d3890b0.png";